const SVG_PROPS = {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

export function OverviewIcon() {
  return (
    <svg {...SVG_PROPS}>
      <rect x="2" y="2" width="5" height="5" rx="1" />
      <rect x="9" y="2" width="5" height="5" rx="1" />
      <rect x="2" y="9" width="5" height="5" rx="1" />
      <rect x="9" y="9" width="5" height="5" rx="1" />
    </svg>
  );
}

export function ProfileIcon() {
  return (
    <svg {...SVG_PROPS}>
      <circle cx="8" cy="5.5" r="2.5" />
      <path d="M3 13.5c0-2.2 2.2-3.5 5-3.5s5 1.3 5 3.5" />
    </svg>
  );
}

export function SecurityIcon() {
  return (
    <svg {...SVG_PROPS}>
      <path d="M8 2 3 4v4c0 2.8 2.1 5.3 5 6 2.9-.7 5-3.2 5-6V4l-5-2z" />
    </svg>
  );
}

export function CredentialsIcon() {
  return (
    <svg {...SVG_PROPS}>
      <circle cx="5" cy="8" r="2.5" />
      <path d="M7.5 8 14 8" />
      <path d="M11.5 8v2" />
      <path d="M13.5 8v1.5" />
    </svg>
  );
}

export function SessionsIcon() {
  return (
    <svg {...SVG_PROPS}>
      <rect x="2" y="3" width="12" height="8" rx="1" />
      <path d="M6 14h4" />
      <path d="M8 11v3" />
    </svg>
  );
}

export function DataIcon() {
  return (
    <svg {...SVG_PROPS}>
      <path d="M9 2H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6L9 2z" />
      <polyline points="9 2 9 6 13 6" />
    </svg>
  );
}

export function ConnectedAppsIcon() {
  return (
    <svg {...SVG_PROPS}>
      <rect x="1.5" y="4.5" width="6" height="6" rx="1.5" />
      <rect x="8.5" y="4.5" width="6" height="6" rx="1.5" />
      <path d="M7.5 7.5h1" />
    </svg>
  );
}

export function AuditLogIcon() {
  return (
    <svg {...SVG_PROPS}>
      <path d="M3 4h10" />
      <path d="M3 8h8" />
      <path d="M3 12h5" />
      <circle cx="12" cy="12" r="3" />
      <path d="M14.1 14.1 16 16" />
    </svg>
  );
}

export function McpIcon() {
  return (
    <svg {...SVG_PROPS}>
      <rect x="2" y="3" width="12" height="4" rx="1" />
      <rect x="2" y="9" width="12" height="4" rx="1" />
      <path d="M5 5h.01M5 11h.01" />
    </svg>
  );
}
